import { useLocalization } from "@fluent/react";
import { useFeature } from "byzantine";
import { ContextForm } from "cerulean";
import DropdownField from "../../form/DropdownField";
import { useIsNprEnabled } from "../../../src/modules/nonPermanentResidents/hooks/useIsNprEnabled";

const AccountTypeDropdown = () => {
  const { l10n } = useLocalization();
  const { featureEnabled } = useFeature();
  const { isBusinessNprEnabled, isConsumerNprEnabled } = useIsNprEnabled();
  const accountTypes = [
    {
      displayName: l10n.getString("label-personal", null, "Personal"),
      value: "personal",
    },
    {
      displayName: l10n.getString("label-business", null, "Business"),
      value: "business",
    },
  ];

  const isPersonalBankingEnabled =
    featureEnabled("personal_banking") && isConsumerNprEnabled;
  const isBusinessBankingEnabled =
    featureEnabled("business_banking") && isBusinessNprEnabled;

  const filteredBusinessTypes = accountTypes.filter(
    (type) =>
      (type.value === "personal" && isPersonalBankingEnabled) ||
      (type.value === "business" && isBusinessBankingEnabled)
  );

  return (
    <ContextForm.Field required key="account_type">
      <DropdownField
        options={filteredBusinessTypes}
        field="user_category"
        label={l10n.getString("label-account-type", null, "Account type")}
      />
    </ContextForm.Field>
  );
};

export default AccountTypeDropdown;
